// Foundations
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

// Models
import { FranchiseLocation } from '../../../models/franchise.model';
import { ReservationRequestItem } from 'src/app/models/reservation/reservation-request.model';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { MyProfileService } from '../../../services/my-profile.service';
import { InterviewRequestService } from '../../../services/interview-request.service';
import { ReservationRequestService } from '../../../services/reservation/reservation-request.service';

// Components
import { CampLocationSearchSelectComponent } from '../../_share/camp-location-search-select/camp-location-search-select.component';

@Component({
  selector: 'app-reservation-location',
  templateUrl: './reservation-location.component.html',
  styleUrls: ['./reservation-location.component.scss'],
})
export class ReservationLocationComponent implements OnInit, OnDestroy {
  // #region -> Property - Component IO <-
  // ----------

  @Input() reservationRequest$: Observable<ReservationRequestItem>;
  reservationRequest: ReservationRequestItem = new ReservationRequestItem({});
  reservationRequestSubscription: Subscription;

  @Output() navigateToNext = new EventEmitter();
  @Output() selectedLocationOut = new EventEmitter<FranchiseLocation>();
  @ViewChild('searchSelect', { static: false })
  searchSelect: CampLocationSearchSelectComponent;

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Property - Form <-
  // ----------

  form: FormGroup;

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Property - Location <-
  // ----------
  campId;

  locationList: FranchiseLocation[];
  selectedLocation: FranchiseLocation;

  newOpt: FranchiseLocation;
  step = 1;
  selectedCampId: number;
  isBtnEnabled = false;

  // ----------
  // #endregion

  /////////////////////////////

  constructor(
    private route: ActivatedRoute,
    private _analytics: AnalyticsService,
    public myProfileService: MyProfileService,
    public interviewRequestService: InterviewRequestService,
    private reservation: ReservationRequestService
  ) {
    // Location ID
    this.campId = +this.route.snapshot.queryParams.campId;
  }

  ngOnInit(): void {
    //
    this.reservationRequestSubscription = this.reservationRequest$.subscribe(
      (newReservationRequest) => {
        this.reservationRequest = this.reservationRequest.update({
          ...newReservationRequest.json(),
        });

        // Fetch the location data
        this.fetchData();
      }
    );
  }

  ngOnDestroy(): void {
    //
    this.reservationRequestSubscription.unsubscribe();
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  changeSelectedLocationTile(location: FranchiseLocation): void {
    this.selectedLocation =
      this.selectedLocation && location.id === this.selectedLocation.id
        ? null
        : location;
  }

  onSave(): void {
    // Just emit the "selected location", let the parent page to decide what to do the next.
    this.selectedLocationOut.emit(this.selectedLocation);
    // this.navigateToNext.emit();
  }

  isNewOptUnique(id: string): boolean {
    this.locationList.forEach((location) => {
      if (location.id === id) {
        return false;
      }
    });
    return true;
  }

  onConfirmSelect(): void {
    this._analytics.logButtonTap('reservationRequest_saveNewLocation');

    /*
      With the "new" selection, we need to check if this selection is the one from the existing location list.
      If "yes", no need to show the "New Selection" section.
     */
    if (
      this.reservationRequest.isNewLocationSelected(
        this.searchSelect.currentSelection,
        this.locationList
      )
    ) {
      this.newOpt = this.searchSelect.currentSelection;
      if (this.newOpt) {
        this.selectedLocation = this.newOpt;
      }
    }

    this.step = 1;
  }

  handleSelectedCampId(id: number): void {
    this.isBtnEnabled = !!id;
    this.selectedCampId = id;
  }

  gotoStep2(): void {
    this._analytics.logLinkTap('reservationRequest_chooseDifferentLocation');
    this.step = 2;
  }

  /**
   * Fetch the data for prep.
   */
  fetchData() {
    //
    this.myProfileService.locationList$.subscribe((locationList) => {
      //
      this.locationList = locationList;

      /*
        Decide the "selection".
        Rules:
        - If `order request" has data, use it.
        - If `campId` has value passed (selected location), use it.
        - Last, choose the `first one` - the preferred location
       */
      if (this.reservationRequest.selectedLocation) {
        this.selectedLocation = this.reservationRequest.selectedLocation;
        // Decide if the current selection is a "new" location
        if (
          this.reservationRequest.isNewLocationSelected(
            this.reservationRequest.selectedLocation,
            locationList
          )
        ) {
          this.newOpt = this.reservationRequest.selectedLocation;
        } else {
          this.newOpt = undefined;
        }
      } else {
        this.selectedLocation = this.locationList[0];
        this.locationList.forEach((location) => {
          if (location.id === this.campId?.toString()) {
            this.selectedLocation = location;
          }
        });
      }
    });
  }
}
